import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, of, throwError } from "rxjs";
import { MockedHotelsService } from "../model/mocks/hotels.service.mock";
import { HotelsServiceRoutes } from "./hotels.routes";
import { environment } from "src/app/core/environments/environment";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";

@Injectable({
  providedIn: "root",
})
export class HotelsService {
  constructor(private HttpClient: HttpClient, private routerService: RouterService) {}
  loadHotelFilterOptions(requestQuery: any) {
    //TODO: complete types and get it as props
    return this.HttpClient.post(
      `${environment.ms_hotels_base_url}/loadAllFilterOptions`,
      requestQuery
    ).pipe(
      map((res: any) => res),
      catchError((error: any) => {
        if (error.status === 500) {
          return of(MockedHotelsService.getHotelsMock.response);
        } else {
          console.error("Error:", error);
        }
        this.getFilterFailed();
        throw error;
      })
    );
  }
  getHotels(getHotelsRequest: any) {
    //TODO: complete types and get it as props

    return this.HttpClient.post(
      `${environment.ms_hotels_base_url}/filterAndSort`,
      getHotelsRequest
    ).pipe(
      map((res: any) => res),
      catchError((error: any) => {
        if (error.status === 500) {
          return of(MockedHotelsService.getHotelsMock.response);
        } else {
          console.error("Error:", error);
        }
        this.getFilterFailed();
        throw error;
      })
    );
  }
  getFilterFailed() {
    this.routerService.setFilterState(true);
  }
}
